import SEOHead from '@/components/base/SEOHead';
import HeroBanner from './components/HeroBanner';
import LiveMatches from './components/LiveMatches';
import HotCategories from './components/HotCategories';
import LatestArticles from './components/LatestArticles';
import StatsSection from './components/StatsSection';
import CTASection from './components/CTASection';

export default function Home() {
  const homeSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '好博体育',
    url: 'https://haobo-sports.com/',
    description: '好博体育是领先的专业体育竞技娱乐平台，汇聚全球顶级赛事资源，提供足球、篮球、网球等多项运动的实时数据与竞猜服务。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://haobo-sports.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '好博体育提供哪些体育赛事？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '好博体育平台汇聚全球顶级赛事资源，覆盖足球、篮球、网球、电竞、乒乓球、羽毛球等多个体育项目，提供实时数据、深度分析和专业预测服务。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在好博体育注册账号？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过好博体育官网首页点击"立即注册"按钮，填写基本信息即可完成注册。注册后即可享受全方位的赛事数据分析和预测服务。',
        },
      },
      {
        '@type': 'Question',
        name: '好博体育平台是否安全可靠？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '好博体育以安全、公正、便捷为核心，采用多重加密技术保障用户数据安全，严格的风控体系确保平台公正，已获得超过50万用户的信赖和98%的好评率。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="好博体育 - 专业体育竞技平台，畅享全球赛事体验"
        description="好博体育是领先的专业体育竞技娱乐平台，汇聚全球顶级赛事资源，提供足球、篮球、网球等多项运动的实时数据与竞猜服务。好博体育以安全、公正、便捷为核心，为广大体育爱好者打造极致的赛事体验平台，立即注册享受专属福利。"
        keywords="好博体育,好博体育官网,好博体育平台,好博体育注册,好博体育登录,好博体育竞猜,好博体育赛事直播"
        canonicalUrl="https://haobo-sports.com/"
        schemaJson={[homeSchema, faqSchema]}
      />
      <HeroBanner />
      <LiveMatches />
      <HotCategories />
      <LatestArticles />
      <StatsSection />
      <CTASection />
    </>
  );
}